import apiClient from "../utils/apiClient";

export const getCollections = async () => {
  try {
    const response = await apiClient.get(`/collections`);
    return response?.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const getCollectionByName = async (name) => {
  try {
    const response = await apiClient.get(`/collection/${name}`);
    return response?.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const getSeasons = async () => {
  try {
    const response = await apiClient.get(`/seasons`);
    return response?.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const getHotelsByCollectionAndSeason = async (arrData) => {
  try {
    const response = await apiClient.post(
      `/collections/hoteles/seccion`,
      arrData
    );
    return response?.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};
